@import '../../../../../../../static/less/variables';

.header {
  font-weight: 600;
}

.o-discount-section {
  margin: 40px 0;

  .list-group-item {
    .inline {
      word-break: normal;
    }
  }
}

.pagination {
  margin: 30px 0 0 0;
  li {
    cursor: pointer;
    &.btn-numbered-page,
    &.btn-prev-page,
    &.btn-next-page,
    &.btn-next-more,
    &.btn-prev-more {
      &.active {
        a {
          -webkit-box-shadow: 0 24px -8px -4px rgba(196, 196, 196, 0.8);
          -moz-box-shadow: 0 24px -8px -4px rgba(196, 196, 196, 0.8);
          box-shadow: 0 9px 24px -8px rgba(196, 196, 196, 0.8);
        }
      }
      a {
        margin: 0 7px;
        background: #fff;
        font-weight: 600;
        border-radius: 5px;
      }
    }
    &.btn-prev-page,
    &.btn-next-page {
      a {
        margin: 0 50px;
      }
    }
  }
}



// WEBPACK FOOTER //
// webpack:///sef/pro/assets/routes/ManagementPanel/routes/Billing/components/Billing.less